//引入vue
import Vue from 'vue';
//引入vue路由
import VueRouter from 'vue-router';
// require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
const Index = resolve => {
	require.ensure(['../pages/index/index.vue'], () => {
		resolve(require('../pages/index/index.vue'));
	});
};
const News = resolve => {
	require.ensure(['../pages/news/news.vue'], () => {
		resolve(require('../pages/news/news.vue'));
	});
};
//使用路由
Vue.use(VueRouter);

//路由配置
const $router = new VueRouter({
	base: '/',
	mode: 'history', //'hash'
	// base: process.env.BASE_URL,
	routes: [{
			path: '/',
			redirect: '/index',
			component: Index
		},
		{
			path: '/index',
			name: 'index',
			component: Index
		},
		{
			path: '/news',
			name: 'news',
			component: News
		},
		{
			path: '/news:newsid',
			name: 'news',
			component: News
		},
		{
			path: '*',
			component: Index
			// ES7的懒加载，webpack2官网推荐使用,需要配合babel的syntax-dynamic- 
			// component: () => import('../pages/index/index.vue')
		}
	]
});
// 解决Loading chunk (\d)+ failed问题
$router.onError((error) => {
	const pattern = /Loading chunk (\d)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	debugger
	const targetPath = router.history.pending.fullPath;
	if (isChunkLoadFailed) {
		router.replace(targetPath);
	}
});

//路由导出
export default $router;
